import { takeLatest, put, call, SagaReturnType } from 'redux-saga/effects';
import { dailySessionNotes } from '../../actions/constant';
import dailySessionNotesService from 'src/services/apiServices/dailySessionNotes/dailySessionNotes';

const {
  ARCHIVE_DAILY_SESSION_NOTE_REQUEST,
  ARCHIVE_DAILY_SESSION_NOTE_SUCCESS,
  ARCHIVE_DAILY_SESSION_NOTE_FAILURE,
  ARCHIVE_DAILY_SESSION_NOTE_LOADING,
} = dailySessionNotes;

function* archiveDailySessionNote(action: any): SagaReturnType<any> {
  try {
    yield put({ type: ARCHIVE_DAILY_SESSION_NOTE_LOADING });
    const response = yield call(dailySessionNotesService.archiveDailySessionNote, action?.payload);
    //  The service answers 200 on success; a 201 would be equally valid for a POST that
    //  creates the hold record, so accept both rather than falling into the failure branch.
    if (response?.status === 200 || response?.status === 201) {
      yield put({
        type: ARCHIVE_DAILY_SESSION_NOTE_SUCCESS,
        payload: { response: response.data, dsnUuid: action?.payload?.dsnUuid },
      });
    } else {
      throw response?.data;
    }
  } catch (error: any) {
    //  BOPS-151: the two refusals the backend can return — no billable codes, and no saved
    //  PDF because the note was never submitted — arrive as an error body with a message.
    //  Keep the whole response so the caller can surface that message instead of a raw error.
    yield put({
      type: ARCHIVE_DAILY_SESSION_NOTE_FAILURE,
      payload: error?.response?.data || error,
    });
  }
}

function* archiveDailySessionNoteSaga() {
  yield takeLatest(ARCHIVE_DAILY_SESSION_NOTE_REQUEST, archiveDailySessionNote);
}

export default archiveDailySessionNoteSaga;
